export class CenterUser {

    public relations = ['user', 'center'];

    public profile_fields = ['user_id'];


    public names = {
        user_id: function (data) {
            if(!data.user){
                return 'нет';
            }
            return data.user.f + ' ' + data.user.i + ' '  + data.user.o;
        },

        center_id: function (data) {
            if(!data.center){
                return 'нет';
            }
            return data.center.name;
        },
        //
        // therapist_schedule_id: function (data) {
        //     if(!data.therapist_schedule){
        //         return 'нет';
        //     }
        //     return data.therapist_schedule.date_time;
        // },
    }
}
